import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_ACCOUNT_PENDING_POINTS } from 'actions/apiActionConstants'
import requestLoyaltyAccountPendingPoints from 'api/loyalty/requestLoyaltyAccountPendingPoints'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'

function fetchLoyaltyAccountPendingPoints(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const memberId = state.auth.account.memberId
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const pendingPoints = state.loyalty.accountPendingPoints

    if (
      !getIsLoyaltyEnabled(state) ||
      !memberId ||
      !hasLoyaltyAccount ||
      pendingPoints.fetching ||
      pendingPoints.data ||
      pendingPoints.error
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_ACCOUNT_PENDING_POINTS,
      request: () => requestLoyaltyAccountPendingPoints(memberId),
    })
  }
}

export default fetchLoyaltyAccountPendingPoints
